import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import FreeMessagesInfoSection_vue_vue_type_script_setup_true_lang_default from "./FreeMessagesInfoSection.vue.script.js";
/* empty css                                      */
//#region src/components/FreeMessagesInfoSection.vue
var FreeMessagesInfoSection_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FreeMessagesInfoSection_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-1921dede"]]);
//#endregion
export { FreeMessagesInfoSection_default as default };

//# sourceMappingURL=FreeMessagesInfoSection.vue.js.map